import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { relatedBlogPostDispatchers as dispatchSelector } from 'reduxModules/blogPosts/dispatchers'
import { blogPostsStateSelector as stateSelector } from 'reduxModules/blogPosts/selectors'
import BlogPostStructure from '../../BlogPosts/BlogPost/propTypes'
import template from './template.rt'
import './styles.css'

export class RelatedBlogPosts extends Component {
  componentDidMount() {
    const { user, loadRelatedBlogPosts } = this.props
    loadRelatedBlogPosts(user)
  }

  shouldComponentUpdate(nextProps) {
    if (
      !_.isEqual(this.props.blogPosts, nextProps.blogPosts) ||
      this.props.currentBlogPostId !== nextProps.currentBlogPostId
    )
      return true
    return false
  }

  getBlogPosts() {
    const { blogPosts, currentBlogPostId } = this.props
    const validBlogposts = _.reject(blogPosts, { id: currentBlogPostId })
    return _.sampleSize(validBlogposts, 3)
  }

  render() {
    return template.call(this)
  }
}

RelatedBlogPosts.propTypes = {
  loadRelatedBlogPosts: PropTypes.func.isRequired,
  blogPosts: PropTypes.arrayOf(PropTypes.shape(BlogPostStructure)).isRequired,
  user: PropTypes.number.isRequired,
  currentBlogPostId: PropTypes.number.isRequired
}

export default connect(
  stateSelector,
  dispatchSelector
)(RelatedBlogPosts)
